var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-markdown',_vm._b({staticClass:"md"},'vue-markdown',_vm.options,false),[_vm._v(_vm._s(_vm.markdown))])}
var staticRenderFns = []

export { render, staticRenderFns }